import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from '../components/login/login';
import Login1 from '../components/login/login1';
import Chat from '../components/chatbot/FinanceIQ.js';
import SSOLogin from '../components/login/ssologin';
import ForgotPassword from '../components/forgot-password/forgotPassword';
import ResetPassword from '../components/forgot-password/forgotPassword';
import NotFound from '../components/not-found/notFound';
import Password from '../components/password/password';
import Main from '../components/main/main';
import SideMenu from '../components/side-menu/sideMenu';
import DashBoard from '../components/process/migrations/dashboard/dashboard';
import ComplainceCertificateFileUpload from '../components/process/complaince-certficate/file-upload/file-upload';
import ComplainceCertificateDashboard from '../components/process/complaince-certficate/dashboard/dashboard';
import ComplainceCertificateReport from '../components/process/complaince-certficate/reports/reports';
import MedicalInsuranceFileUpload from '../components/process/medical-insurance/file-upload/file-upload';
import MedicalInsuranceReport from '../components/process/medical-insurance/reports/reports';
import MedicalInsuranceDashboard from '../components/process/medical-insurance/reports/dashboard';
import MigrationDashboard from '../components/process/migrations/dashboard/dashboard';
import DonutChart from '../components/process/etl/donutchart';
import Header from '../components/header/header';
import Etl from '../components/process/etl/etl';
import Etlsecound from '../components/process/etl/etlsecoud';
import Etlsecound1 from '../components/process/etl/etlsecoud1.js';
import Etlsecound2 from '../components/process/etl/etlsecoud2';
import Etlrelation from '../components/process/etl/etlrealations';
import P2p from '../components/process/etl/p2p';
import Kpi from '../components/process/etl/kpi';
import Kpi2 from '../components/process/etl/kpi2';
import Kpi3 from '../components/process/etl/kpi3';
import Trip from '../components/process/etl/trip';
import Report from '../components/process/etl/report';
import HeaderConfig2 from '../components/process/etl/header_config2';
import QueryBuilder from '../components/process/etl/querybuilder';
import ApexChart from '../components/process/etl/apexdontchart';
import Table from '../components/process/etl/table';
import Home from '../components/process/etl/home';
import Details from '../components/process/etl/detail';
import Vendorcrdr from '../components/process/etl/SAGARBHANGA/vendorcddr';
import SagarbhaReport from '../components/process/etl/SAGARBHANGA/sagarbhareport';
import Consolidation from '../components/process/etl/consolidation';
import ProcessMaster from '../components/process/etl/resource_master';
import ResourceMaster1 from '../components/process/etl/resource_master1';
import Etl1 from '../components/process/etl/etl1';
import AlcsFileUpload from '../components/process/alcs/file-upload/file-upload';
import AlcsReport from '../components/process/alcs/reports/reports';
import EmailsList from '../components/process/alcs/EmailsList';
import Glmapping from '../components/process/VRS/glmapping';


import AlcsKpi from '../components/process/alcs/dashboard/dashboard';

import Consolidation_file_upload from '../components/process/etl/consolidation_upload/file-upload/file-upload';
import Consolidation_report from '../components/process/etl/consolidation_upload/reports/reports';
import Consolidationdashboard from '../components/process/etl/consolidation_upload/dashboard/dashboard';

import VRSEmailsList from '../components/process/alcs/VrsEmailsList';

import P2pDashboard from '../p2p/components/dashboard/dashboard';
import Porequirement from '../p2p/components/porequirement/porequirement';
import Podeptheadtracker from '../p2p/components/podeptheadtracker/podeptheadtracker';
import Poapprovaltracker from '../p2p/components/poapprovaltracker/poapprovaltracker';
import Pofinancetracker from '../p2p/components/pofinancetracker/pofinancetracker';
import P2ptracker from '../p2p/components/p2ptracker/p2ptracker';
import OverallprfComponent from '../p2p/components/overallprf/overallprf';
import UsermasterComponent from '../p2p/components/usermaster/usermaster';

import Porequirement1 from '../p2p/components/porequirement/porequirment1';
import TenantsMaster from '../components/process/user-management/tenants';
import ReconSummary from '../components/process/VRS/arreconsummary.js';
import OrgRegistartion from '../components/process/registration_forms/org_structure';
import AdminRegistartion from '../components/process/registration_forms/admin_registration';
import ApprovelForm from '../components/process/registration_forms/approvel';
import UserLoginForm from '../components/process/registration_forms/user_login.js';
import OrgHierachy from '../components/process/registration_forms/org_hierachy.js';
import Pages from '../components/process/registration_forms/pages.js';
import ReportConfig from '../components/process/registration_forms/report_configuration.js';
import Process1 from '../components/process/registration_forms/process.js';
import Roles from '../components/process/registration_forms/roles.js';
import Usercreation from '../components/process/registration_forms/user_creation.js';
import MatchingRules from '../components/process/etl/matching_rule';
import KpiNew from '../components/process/etl/kpi_new';
import Relationship from '../components/process/etl/relationship';
import Process from '../components/process/etl/process';
import AsDashboard from '../components/process/26as/dashboard';
import Permission from '../components/process/etl/permission';

import LandingPageGrid from '../components/process/landing_page';

import CustomerMapping from '../components/process/etl/customer_mapping';
import DashboardComponent from '../components/process/BRS/dashboard_new';
import FinDasboard from '../components/process/BRS/fin_dashboard';
import ExcelSheet from '../components/process/VRS/excel_sheet';
import VendorConfig from '../components/process/VRS/vendor_config';
import NewMail from '../components/process/etl/new_mail.js';

import ReadMailInfo from '../components/process/etl/readmailinfo.js'
import Fileconfig from '../components/process/etl/fileconfig.js'
import DashboardVRS1 from '../components/process/VRS/dashboard_new.js';
import DashboardVRS2 from '../components/process/VRS/dashboard_new1.js';
import Emails_send_readVRS1 from '../components/process/VRS/emails_send_read_1.js';
import ReconsummaryVrs from '../components/process/VRS/reconSummary.js';
import ReconsummaryVrs1 from '../components/process/VRS/reconSummary1.js';
import ReconsummaryVrs2 from '../components/process/VRS/reconSummary2.js';
import Brsfileupload from '../components/process/VRS/file-upload/file-upload.js';
import ASfileupload from '../components/process/VRS/file-upload/arfileupload.js';
import Brsreport from '../components/process/VRS/vrsreport1.js';
import Emailslist1 from '../components/process/VRS/EmailsList.js';
import ReconsummaryVrs7 from '../components/process/VRS/reconSummary7.js';
import ReconsummaryVrs8 from '../components/process/VRS/reconSummary8.js';
import Zetvrsreport from '../components/process/VRS/vrsreport2.js';
import VrsReports from '../components/process/VRS/vrsreport3.js';
import VrsEmailsList from '../components/process/VRS/vrsemailsList.js';
import Mailsummary from '../components/process/medical-insurance/mailsummary.js';
import AsReconsummary from '../components/process/VRS/26asreconSummary.js';
import AsReconreport from '../components/process/VRS/26asreports.js';
import Department from '../components/process/po_process/department.js';
import Vendormaster from '../components/process/po_process/vendormaster.js';
import Purchaserequirement from '../components/process/po_process/purchaserequirement.js';
import Purchaserequirement1 from '../components/process/po_process/purchaserequirement1.js';
import TbMapping from '../components/process/glrecon/tbmapping.js';
import TbExecution from '../components/process/glrecon/tbexecution.js';
import TbUpload from '../components/process/glrecon/tbfileupload.js';
import Prfreport from '../components/process/po_process/prfreport.js';
import Prfdisplayer from '../components/process/po_process/prfdisplayer.js';
import Approverscreen from '../components/process/po_process/approverscreen.js';
import P2papproverscreen from '../components/process/po_process/p2papproverscreen.js';
import Finapproverscreen from '../components/process/po_process/finapproverscreen.js';
import BudgetMaster from '../components/process/po_process/budgetmaster.js';
import Costing from '../components/process/po_process/costing.js';
import CostingApprover from '../components/process/po_process/costing_approver.js';
import Bsrresult from '../components/process/BSR/bsrreport';
import CtcValidation from '../components/process/BSR/ctc_configuration';
import Tbrs from '../components/process/txbrs/reconSummary8';
import TFileUpload from '../components/process/txbrs/file-upload';
import DbrsReport from '../components/process/txbrs/vrsreport1';
import BrsDashboard from '../components/process/txbrs/dashboard_new';
import BalanceClosing from '../components/process/txbrs/balanceclosing';
import ARFileUploads from '../components/process/ar/arfileupload';
import ARRecon from '../components/process/ar/arreconsummary';
import FundRecon from '../components/process/ar/fundreconsummary';
import ARDashboards from '../components/process/ar/dashboard_new';
import Txasreco from '../components/process/26as/asrecosummary';
import Txdashboard from '../components/process/26as/dashboard';

import Pomapping from '../components/process/payments/pomapping.js';
import SbiCenspocscreen from '../components/process/payments/sbicentralspocscreen.js';
import PdfConfig from '../components/process/payments/pdf_configuration';
import SbiPomapping from '../components/process/payments/sbipomapping.js';
import UtrUpdate from '../components/process/payments/utrupdate.js';
import Milestones from '../components/process/payments/milestones.js';
import SbiMilestones from '../components/process/payments/sbimilestones.js';
import Inventry from '../components/process/payments/sbiinvoicedetailsentry.js';
import AddPurchaseOrder from '../components/process/payments/add_purchase_order.js';
import AddContract from '../components/process/payments/add_contract.js';
import SbiAddContract from '../components/process/payments/sbi_add_contract.js';
import Expensecategory from '../components/process/payments/expensecategory.js';
import Addattachment from '../components/process/payments/addattachment.js';

import InstitutionalInvoices from '../components/process/payments/institutional_invoice_report.js';
import InstitutionalFileupload from '../components/process/payments/institutional_fileupload.js';
import Dashboard123 from '../components/process/payments/dashboard.js';
import Invoiceentry from '../components/process/payments/invoicedetailsentry.js';
import PaymentsApprover from '../components/process/payments/approver_screen.js';
import FinApprover from '../components/process/payments/fin_approver_screen.js';
import ArInvoices from '../components/process/payments/arinvoices.js';
import CostCentre from '../components/process/payments/costcentre.js';
import SbiCostcentre from '../components/process/payments/sbicostcentre.js';
import MailConfig from '../components/process/configurations/mailer.js';

import ApDashboard from '../components/process/ap/dashboard.js';
import FileReading from '../components/process/ap/file_reading.js';
import Grpo from '../components/process/ap/grpo.js';
import Invoice from '../components/process/ap/invoice.js';
import PurchaseOrder from '../components/process/ap/po.js';
import JvDashboard from '../components/process/jv_reco/dashboard.js';
import JvFileUpload from '../components/process/jv_reco/file_upload.js';
import BrsMailer from '../components/process/jv_reco/brs_mailer.js';
import ScreenBuilder from '../components/process/configurations/screen_config';
import ScreenViewer from '../components/process/configurations/screen_viewer.js';
import StockScreener from '../components/process/upst/StockScreener';
import BackTesting from '../components/process/upst/BackTesting';
import IrnUpload from '../components/process/irn/file_upload.js';
import Budget from '../components/process/irn/budget.js';
import BudgetApproval from '../components/process/irn/budget_approval.js';
import BudgetDashboard from '../components/process/irn/budget_dashboard.js';
import Planner from '../components/process/planning/index.js';
import QrForm from '../components/process/form/QRAdminPanel.jsx';
import SurveyRenderer       from '../components/process/form/survey.jsx';
import Master       from '../components/process/form/masters.jsx';
import MasterDetailCreation      from '../components/process/form/masters_screen.jsx';
import EventGate from '../components/process/form/event_gate_management.jsx';
import EtlConfig from '../components/process/form/etl_configurator_preview.jsx';
import ExcelDisplayer from '../components/process/enterprise_spreadsheet/EnterpriseSpreadsheet.jsx';

// ── Event Platform - 14 Screens (Part 1, Part 2, Part 3) ──────────────────
import { FormFillerDashboard, EventListing, EventDetails } from '../components/process/form/EventPlatform_Part1.jsx';
import { MyApplications, InvitationsPage, EventCreatorDashboard } from '../components/process/form/EventPlatform_Part2.jsx';
import {  InvitationManagement, EventAnalytics, SystemTimeline } from '../components/process/form/EventPlatform_Part3.jsx';
import ProfileCreation from '../components/process/form/school_profile.jsx';
import ClgProfileCreation from '../components/process/form/college_profile.jsx';
import UniversityProfile from '../components/process/form/university_profile.jsx';
import UsUniversityProfile from '../components/process/form/usuniversity_profile.jsx';
import CreateEvent from '../components/process/form/school_create_event.jsx';
import ClgCreateEvent from '../components/process/form/college_create_event.jsx';
import UniCreateEvent from '../components/process/form/university_create_event.jsx';
import EventManagement from '../components/process/form/event_management.jsx';
import ApplicationSubmission from '../components/process/form/event_application.jsx';
import ApplicantReview from '../components/process/form/application_review.jsx';
import SchoolDashboard from '../components/process/form/school_dashboard.jsx';
import UniversityDashboard from '../components/process/form/university_dashboard.jsx';
import GlobalDashboard from '../components/process/form/global_dashboard.jsx';
import Website from '../components/process/website/home.jsx';
import FormResponse from '../components/process/form/form_response.jsx';

class Routing extends React.Component
{
    render()
    {
        return(
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                <div>
                    <Routes>
                        <Route path="/sso" element={<SSOLogin />} />
                        <Route path="/" element = {<Login />} />
                        <Route path="/survey/:slug" element ={< SurveyRenderer/> }/>
                        <Route path="/login/" element = {<Login />} />
                        <Route path="/website" element ={< Website/> }/>
                        <Route path="/forgotpassword" element = {<ForgotPassword />} />
                        <Route path="/ResetPassword" element = {<ResetPassword />} />
                        <Route path="/SideMenu" element = {<SideMenu />} />
                        <Route path="/Header" element = {<Header />} />
                        <Route path="/" element = {<Main />}>
                            <Route path="chat" element={<Chat />} />
                            <Route path="DashBoard" element={<DashBoard />} />
                            <Route path="irnupload" element={<IrnUpload />} />
                            <Route path="arfile" element = {<ARFileUploads />} />
                            <Route path="ardashb" element = {<ARDashboards />} />
                            <Route path="arrecons" element = {<ARRecon />} />
                            <Route path="CCFileUpload" element = {<ComplainceCertificateFileUpload />} />
                            <Route path="CCDashboard" element = {<ComplainceCertificateDashboard />} />
                            <Route path="CCReports" element = {<ComplainceCertificateReport />} />
                            <Route path="MIFileUpload" element = {<MedicalInsuranceFileUpload />} />
                            <Route path="MIReports" element = {<MedicalInsuranceReport />} />
                            <Route path="MigrationDashboard" element = {<MigrationDashboard />} />
                            <Route path="/etl" element = {<Etl/>} />
                            <Route path="/etlsecound" element ={< Etlsecound/> }/>
                            <Route path="/etlrelation" element ={< Etlrelation/> }/>
                            <Route path="/p2p" element ={< P2p/> }/>
                            <Route path="/kpi" element ={< Kpi/> }/>
                            <Route path="/kpi2" element ={< Kpi2/> }/>
                            <Route path="/kpi3" element ={< Kpi3/> }/>
                            <Route path="/trip" element ={< Trip/> }/>
                            <Route path="/report" element ={< Report/> }/>
                            <Route path="/apex" element ={< ApexChart/> }/>
                            <Route path="/donutChart" element ={< DonutChart/> }/>
                            <Route path="/table" element ={< Table/> }/>
                            <Route path="/home" element ={< Home/> }/>
                            <Route path="/details" element ={< Details/> }/>
                            <Route path="/sagar" element ={< SagarbhaReport/> }/>
                            <Route path="/consolidation" element ={< Consolidation/> }/>
                            <Route path="/processmaster" element ={< ProcessMaster/> }/>
                            <Route path="/resourcemaster1" element ={< ResourceMaster1/> }/>
                            <Route path="/etl1" element ={< Etl1/> }/>
                            <Route path="/alcs" element ={< AlcsFileUpload/> }/>
                            <Route path="/alcsreport" element ={< AlcsReport/> }/>
                            <Route path="/emailsList" element ={< EmailsList/> }/>
                            <Route path="/alcsKpi" element ={< AlcsKpi/> }/>
                            <Route path="/vrsemailsList" element ={< VRSEmailsList/> }/>
                            <Route path="/consolidation_file_upload" element ={< Consolidation_file_upload/> }/>
                            <Route path="/consolidation_report" element ={< Consolidation_report/> }/>
                            <Route path="/consolidation_dashboard" element ={< Consolidationdashboard/> }/>
                            <Route path="/p2pDashboard" element ={< P2pDashboard/> }/>
                            <Route path="/porequirement" element ={< Porequirement/> }/>
                            <Route path="/qrform" element ={< QrForm/> }/>
                            <Route path="/master" element ={< Master/> }/>
                            <Route path="/masterdetailcreation" element ={< MasterDetailCreation/> }/>
                            <Route path="/eventgate" element ={< EventGate/> }/>
                            <Route path="/etlconfig" element ={< EtlConfig/> }/>
                            
                            <Route path="/podeptheadtracker" element ={< Podeptheadtracker/> }/>
                            <Route path="/poapprovaltracker" element ={< Poapprovaltracker/> }/> 
                            <Route path="/poapprovaltracker1" element ={< Porequirement1/> }/> 
                            <Route path="/pofinancetracker" element ={< Pofinancetracker/> }/>
                            <Route path="/p2ptracker" element ={< P2ptracker/> }/>
                            <Route path="/form_response" element ={< FormResponse/> }/>
                            {/*<Route path="/consolidationdocupload" element ={< Consolidationdocupload/> }/>
                            <Route path="/consolidationprocess" element ={< Consolidationprocess/> }/>
                            <Route path="/consolidationreport" element ={< Consolidationreport/> }/>
                            <Route path="/sourcedefinition" element ={< Sourcedefinition/> }/>
                            <Route path="/source" element ={< SourceComponent/> }/>*/}
                            <Route path="/overallprf" element ={< OverallprfComponent/> }/>
                            <Route path="/user" element ={< UsermasterComponent/> }/> 
                            {/* <Route path="/p2preport" element ={< P2preportComponent/> }/> */}
                            {/* <Route path="/departmentMaster" element ={< DepartmentMasterComponent/> }/>
                            <Route path="/vendorMaster" element ={< VendorMasterComponent/> }/>
                            <Route path="/materialMaster" element ={< MaterialMasterComponent/> }/> */}



                            {/* <Route path="/excelFileUpload" element ={< AlcsExcelFileUpload/> }/>  */}

                            <Route path="/etlsecound1" element ={< Etlsecound1/> }/>
                            <Route path="/etlsecound2" element ={< Etlsecound2/> }/>


                            <Route path="/tenants" element ={< TenantsMaster/> }/>
    			            <Route path="MIDashboard" element = {<MedicalInsuranceDashboard />} />
                            <Route path="/ReconSummary" element ={< ReconSummary/> }/>
                            <Route path="/admin_registration" element ={< AdminRegistartion/> }/>
                            <Route path="/orgregistartion" element ={< OrgRegistartion/> }/>
                            <Route path="/approvel_Form" element ={< ApprovelForm/> }/>
                            <Route path="/pages" element ={< Pages/> }/>
                            <Route path="/process1" element ={< Process1/> }/>
                            <Route path="/userroles" element ={< Roles/> }/>
                            <Route path="/user_login" element ={< UserLoginForm/> }/>
                            <Route path="/bsrresult" element ={< Bsrresult/> }/>
                            <Route path="/ctcvalidation" element ={< CtcValidation/> }/>


                            <Route path="/reportconfig" element ={< ReportConfig/> }/>
                            <Route path="/matching_rules" element ={< MatchingRules/> }/>
                            <Route path="/kpi_new" element ={< KpiNew/> }/>
                            <Route path="/relationship" element ={< Relationship/> }/>
                            <Route path="/process" element ={< Process/> }/>
                            <Route path="/permission" element ={< Permission/> }/>
                            
                            <Route path="/landing_page" element ={< LandingPageGrid/> }/>
                            <Route path="/headerconfig2" element ={< HeaderConfig2/> }/>
                            <Route path="/querybuilder" element ={< QueryBuilder/> }/>
                            <Route path="/customer_mapping" element ={< CustomerMapping/> }/>
                            <Route path="/dashboard1" element ={< DashboardComponent/> }/>
                            <Route path="/fin_dashboard" element ={< FinDasboard/> }/>
                            {/* <Route path="/test" element ={< Test/> }/> */}
                            {/* <Route path="/excel" element ={< exc/> }/> */}
                            <Route path="/excel_sheet" element ={< ExcelSheet/> }/>
                            <Route path="/new_mail" element ={< NewMail/> }/>
                            <Route path="/read_mail_info" element ={< ReadMailInfo/> }/>
                            <Route path="/dashboardvrs1" element ={< DashboardVRS1/> }/>
                            <Route path="/dashboardvrs2" element ={< DashboardVRS2/> }/>
                            <Route path="/refupdate" element ={< UtrUpdate/> }/>
                            <Route path="/emails_send_read_vrs1" element ={< Emails_send_readVRS1/> }/>
                            <Route path="/reconsummaryvrs1" element ={< ReconsummaryVrs/> }/>
                            <Route path="/reconsummaryvrs2" element ={< ReconsummaryVrs1/> }/>
                            <Route path="/reconsummaryvrs3" element ={< ReconsummaryVrs2/> }/>
                            <Route path="/brsfileupload" element ={< Brsfileupload/> }/>
                            <Route path="/26asfileupload" element ={< ASfileupload/> }/>
                            <Route path="/brsreport" element ={< Brsreport/> }/>
                            <Route path="/vendoremail" element ={< VrsEmailsList/> }/>
                            <Route path="/txbrs" element ={< ReconsummaryVrs8 /> }/>
                            <Route path="/department" element ={< Department/> }/>
                            <Route path="/vendormaster" element ={< Vendormaster/> }/>
                            <Route path="/purchaserequirement" element ={< Purchaserequirement/> }/>
                            <Route path="/purchaserequirement1" element ={< Purchaserequirement1/> }/>

                            <Route path="/pomapping" element ={< Pomapping/> }/>
                            <Route path="/spocpomapping" element ={< SbiPomapping/> }/>
                            <Route path="/ceninv" element ={< SbiCenspocscreen/> }/>
                            <Route path="/milestones" element ={< Milestones/> }/>
                            <Route path="/spocmilestones" element ={< SbiMilestones/> }/>
                            <Route path="/addpo" element ={< AddPurchaseOrder/> }/>
                            <Route path="/addcontract" element ={< AddContract/> }/>
                            <Route path="/spocaddcontract" element ={< SbiAddContract/> }/>
                            <Route path="/institutional_fileupload" element ={< InstitutionalFileupload/> }/>
                            <Route path="/dashboard123" element ={< Dashboard123/> }/>
                            <Route path="/fileconfig" element ={< Fileconfig/> }/>
                            <Route path="/institutionalreport" element ={< InstitutionalInvoices/> }/>
                            <Route path="/orghierachy" element ={< OrgHierachy/> }/>
                            <Route path="/prfreport" element ={< Prfreport/> }/>
                            <Route path="/prfdisplayer" element ={< Prfdisplayer/> }/>
                            <Route path="/approverscreen" element ={< Approverscreen/> }/>
                            <Route path="/p2papproverscreen" element ={< P2papproverscreen/> }/>
                            <Route path="/finapproverscreen" element ={< Finapproverscreen/> }/>
                            <Route path="/budgetmaster" element ={< BudgetMaster/> }/>
                            <Route path="/cost_quotation" element ={< Costing/> }/>
                            <Route path="/cost_approval" element ={< CostingApprover/> }/>
                            <Route path="/invoiceentry" element ={< Invoiceentry/> }/>
                            <Route path="/invoiceapproval" element ={< PaymentsApprover/> }/>
                            <Route path="/finapproval" element ={< FinApprover/> }/>
                            <Route path="/expensecategory" element ={< Expensecategory/> }/>
                            <Route path="/addattachment" element ={< Addattachment/> }/>

                            <Route path="/costcentre" element ={< CostCentre/> }/>
                            <Route path="/sbicostcentre" element ={< SbiCostcentre/> }/>
                            <Route path="/editvendor" element ={< Emailslist1/> }/>
                            <Route path="/brs" element ={< ReconsummaryVrs7/> }/>
                            <Route path="/26asreport" element ={< AsReconreport/> }/>
                            <Route path="/26asrecon" element ={< AsReconsummary/> }/>
                            <Route path="/26asdashboard" element ={< AsDashboard/> }/>
                            <Route path="/zetvrs" element ={< ReconsummaryVrs8/> }/>
                            <Route path="/vendorconfig" element ={< VendorConfig/> }/>
                            <Route path="/Glmapping" element ={< Glmapping/> }/>
                            <Route path="/mailsummary" element ={< Mailsummary/> }/>
                            <Route path="/usercreation" element ={< Usercreation/> }/>
                            <Route path="/tbmapping" element ={< TbMapping/> }/>
                            <Route path="/tbexecution" element ={< TbExecution/> }/>
                            <Route path="/tbupload" element ={< TbUpload/> }/>
                            <Route path="/demobrs" element ={< Tbrs /> }/>
                            <Route path="/demofileupload" element ={< TFileUpload/> }/>
                            <Route path="/demobrsreport" element ={< DbrsReport/> }/>
                            <Route path="/demobrsdashboard" element ={< BrsDashboard/> }/>
                            <Route path="/balanceclosing" element ={< BalanceClosing/> }/>
                            <Route path="/arinvoices" element ={< ArInvoices/> }/>
                            <Route path="/vendorreport" element ={< VrsReports/> }/>
                            <Route path="/txasreco" element ={< Txasreco/> }/>
                            <Route path="/txdashboard" element ={< Txdashboard/> }/>
                            <Route path="/fundingapproval" element ={< FundRecon/> }/>
                            <Route path="/mailconfig" element ={< MailConfig/> }/>
                            <Route path="/inventry" element ={< Inventry/> }/>
                            <Route path="/pdfconfig" element ={< PdfConfig/> }/>
                            <Route path="/jvdashboard" element ={< JvDashboard/> }/>
                            <Route path="/jvfileupload" element ={< JvFileUpload/> }/>
                            

                            <Route path="/apdashboard" element ={< ApDashboard/> }/>
                            <Route path="/fileread" element ={< FileReading/> }/>
                            <Route path="/grpo" element ={< Grpo/> }/>
                            <Route path="/invoice" element ={< Invoice/> }/>
                            <Route path="/purord" element ={< PurchaseOrder/> }/>
                            <Route path="/screenconfig" element ={< ScreenBuilder/> }/>
                            <Route path="/screenviewer" element ={< ScreenViewer/> }/>
                            <Route path="/stockscreener" element ={< StockScreener/> }/>
                            <Route path="/brsmailer" element ={< BrsMailer/> }/>
                            <Route path="/backtesting" element ={< BackTesting/> }/>
                            <Route path="/budget" element ={< Budget/> }/>
                            <Route path="/budgetapproval" element ={< BudgetApproval/> }/>
                            <Route path="/budgetdashboard" element ={< BudgetDashboard/> }/>
                            <Route path="/planning" element ={< Planner/> }/>
                            <Route path="/exceldisplayer" element ={< ExcelDisplayer/> }/>
                            
                            {/* ── Event Platform - 14 Screens ────────────────────────────────────── */}
                            {/* Screen 1: Form Filler Dashboard */}
                            <Route path="/eventplatform/form-filler-dashboard" element ={< FormFillerDashboard/> }/>
                            
                            {/* Screen 2: Profile Creation */}
                            <Route path="/eventplatform/profile-creation" element ={< ProfileCreation/> }/>
                            <Route path="/eventplatform/university-profile" element ={< UniversityProfile/> }/>
                            <Route path="/eventplatform/college-profile" element ={< ClgProfileCreation/> }/>
                            <Route path="/eventplatform/us-university-profile" element ={< UsUniversityProfile/> }/>
                            
                            {/* Screen 3: Event Listing */}
                            <Route path="/eventplatform/event-listing" element ={< EventListing/> }/>
                            
                            {/* Screen 4: Event Details */}
                            <Route path="/eventplatform/event-details" element ={< EventDetails/> }/>
                            
                            {/* Screen 5: Application Submission */}
                            <Route path="/eventplatform/application-submission" element ={< ApplicationSubmission/> }/>
                            
                            {/* Screen 6: My Applications */}
                            <Route path="/eventplatform/my-applications" element ={< MyApplications/> }/>
                            
                            {/* Screen 7: Invitations Page */}
                            <Route path="/eventplatform/invitations" element ={< InvitationsPage/> }/>
                            
                            {/* Screen 8: Event Creator Dashboard */}
                            <Route path="/eventplatform/event-creator-dashboard" element ={< EventCreatorDashboard/> }/>
                            
                            {/* Screen 9: Create Event */}
                            <Route path="/eventplatform/create-event" element ={< CreateEvent/> }/>
                            <Route path="/eventplatform/college-create-event" element ={< ClgCreateEvent/> }/>
                            <Route path="/eventplatform/university-create-event" element ={< UniCreateEvent/> }/>
                            
                            {/* Screen 10: Event Management */}
                            <Route path="/eventplatform/event-management" element ={< EventManagement/> }/>
                            
                            {/* Screen 11: Applicant Review */}
                            <Route path="/eventplatform/applicant-review" element ={< ApplicantReview/> }/>
                            
                            {/* Screen 12: Invitation Management */}
                            <Route path="/eventplatform/invitation-management" element ={< InvitationManagement/> }/>
                            <Route path="/eventplatform/school-dashboard" element ={< SchoolDashboard/> }/>
                            <Route path="/eventplatform/university-dashboard" element ={< UniversityDashboard/> }/>
                            <Route path="/eventplatform/global-dashboard" element ={< GlobalDashboard/> }/>
                            {/* Screen 13: Event Analytics */}
                            <Route path="/eventplatform/event-analytics" element ={< EventAnalytics/> }/>
                            
                            {/* Screen 14: System Timeline */}
                            <Route path="/eventplatform/system-timeline" element ={< SystemTimeline/> }/>
                            


                        </Route>
                        
    
                        
                        <Route path="*" element = {<NotFound />} />
                    </Routes>
                </div>
            </BrowserRouter>
        );
    }
}

export default Routing;